export const GOOGLE_AUTH = "GOOGLE_AUTH";
export const GOOGLE_AUTH_ERROR = "GOOGLE_AUTH_ERROR";
export const AUTHENTICATION_TRUE = "AUTHENTICATION_TRUE";
export const AUTHENTICATION_FALSE = "AUTHENTICATION_FALSE";
export const CREATE_POST_SUCCESS = "CREATE_POST_SUCCESS";
export const CREATE_POST_ERROR = "CREATE_POST_ERROR";
export const GET_POST_SUCCESS = "GET_POST_SUCCESS";
export const GET_POST_ERROR = "GET_POST_ERROR";
export const GET_TAGS_SUCCESS = "GET_TAGS_SUCCESS";
export const GET_TAGS_ERROR = "GET_TAGS_ERROR";
export const CLEAR_POST_SUCCESS_ERROR = "CLEAR_POST_SUCCESS_ERROR";
export const SINGLE_ARTICLE_SUCCESS = "SINGLE_ARTICLE_SUCCESS";
export const SINGLE_ARTICLE_ERROR = "SINGLE_ARTICLE_ERROR";
export const SINGLE_ARTICLE_COMMENTS_SUCCESS = "SINGLE_ARTICLE_COMMENTS_SUCCESS";
export const SINGLE_ARTICLE_COMMENTS_ERROR = "SINGLE_ARTICLE_COMMENTS_ERROR";
export const SUBMIT_COMMENT_SUCCESS = "SUBMIT_COMMENT_SUCCESS";
export const SUBMIT_COMMENT_ERROR = "SUBMIT_COMMENT_ERROR";
export const GET_CURRENT_USER_SUCCESS = "GET_CURRENT_USER_SUCCESS";
export const GET_CURRENT_USER_ERROR = "GET_CURRENT_USER_ERROR";
export const LIKE_ARTICLE_SUCCESS = "LIKE_ARTICLE_SUCCESS";
export const LIKE_ARTICLE_ERROR = "LIKE_ARTICLE_ERROR";
export const DISLIKE_ARTICLE_SUCCESS = "DISLIKE_ARTICLE_SUCCESS";
export const DISLIKE_ARTICLE_ERROR = "DISLIKE_ARTICLE_ERROR";
export const UNFOLLOW_USER_ERROR = "UNFOLLOW_USER_ERROR";
export const UNFOLLOW_USER_SUCCESS = "UNFOLLOW_USER_SUCCESS";
export const FOLLOW_USER_ERROR = "FOLLOW_USER_ERROR";
export const FOLLOW_USER_SUCCESS = "FOLLOW_USER_SUCCESS";
export const DELETE_COMMENT_SUCCESS = "DELETE_COMMENT_SUCCESS";
export const DELETE_COMMENT_ERROR = "DELETE_COMMENT_ERROR";
export const DELETE_COMMENT_RESET = "DELETE_COMMENT_RESET";
export const USER_FEED_SUCCESS = "USER_FEED_SUCCESS";
export const USER_FEED_ERROR = "USER_FEED_ERROR";
export const USER_UPDATE_SUCCESS = "USER_UPDATE_SUCCESS";
export const USER_UPDATE_ERROR = "USER_UPDATE_ERROR";
export const USER_LOGOUT = "USER_LOGOUT";
export const GET_POST_AUTHOR_SUCCESS = "GET_POST_AUTHOR_SUCCESS";
export const GET_POST_AUTHOR_ERROR = "GET_POST_AUTHOR_ERROR";
export const USER_POST_SUCCESS = "USER_POST_SUCCESS";
export const USER_POST_ERROR = "USER_POST_ERROR";
export const TAG_POST_SUCCESS = "TAG_POST_SUCCESS";
export const TAG_POST_ERROR = "TAG_POST_ERROR";